import { createFileRoute, redirect } from "@tanstack/react-router";
import { groupLegalToolsSearch } from "./tools";

/**
 * The cross-BU list's former address (NAV-84). The page is called "Tools
 * across the group" and lives at `/group-legal/tools`; nothing on it says
 * "product" — that is the internal word for a tool's identity across business units
 * (ADR 0016), not the reader's.
 *
 * The filters live in the URL, so a link somebody saved to a narrowed list has
 * to arrive at the same narrowed list: the params are validated here and
 * forwarded rather than dropped.
 */
export const Route = createFileRoute("/group-legal/products")({
  validateSearch: groupLegalToolsSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/group-legal/tools", search, replace: true });
  },
});
